module.exports = __webpack_public_path__ + "static/media/Artboard7.32a3b826.png";